import { getIn } from "@/lib/utils";

export default function getValidationErrors(
  validation_errors: Record<string, never>,
  keyPath: readonly PropertyKey[],
): string[] {
  const target = getIn(validation_errors, keyPath, null) as
    | { msg: string }[]
    | {
        value?: { msg: string }[];
        unit?: { msg: string }[];
        dunit?: { msg: string }[];
        nunit?: { msg: string }[];
      }
    | null;
  if (!target) return [];

  if (Array.isArray(target)) return target.map(({ msg }) => msg);

  return Object.values(target)
    .flat()
    .map(({ msg }) => msg);
}

export function hasSomeValidationErrorsInFields({
  expandedPanelFields: fields,
  errors,
}: {
  expandedPanelFields: string[];
  errors: Record<string, unknown>;
}): boolean {
  return fields.some((field) => Object.keys(errors).includes(field));
}
